import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import {
  railWidthExpanded,
  railWidthCollapsed,
  railTransitionDuration,
  railTransitionEasing,
} from '@/theme/customTheme';

export const useLeftNavRailStyles = makeStyles({
  root: {
    position: 'fixed',
    top: '3rem',
    bottom: '3rem',
    left: '0',
    zIndex: 5,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    boxSizing: 'border-box',
    backgroundColor: tokens.colorNeutralBackground1,
    borderRightWidth: tokens.strokeWidthThin,
    borderRightStyle: 'solid',
    borderRightColor: tokens.colorNeutralStroke2,
    overflowX: 'hidden',
    overflowY: 'auto',
    transitionProperty: 'width',
    transitionDuration: railTransitionDuration,
    transitionTimingFunction: railTransitionEasing,
    ...shorthands.padding(tokens.spacingVerticalM, '0'),
    ...shorthands.gap(tokens.spacingVerticalXXS),
    '@media (prefers-reduced-motion: reduce)': {
      transitionDuration: '0ms',
    },
  },
  rootExpanded: {
    width: railWidthExpanded,
  },
  rootCollapsed: {
    width: railWidthCollapsed,
  },
  list: {
    listStyleType: 'none',
    ...shorthands.padding('0'),
    ...shorthands.margin('0'),
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalXXS),
  },
  listItem: {
    listStyleType: 'none',
  },
  flyoutContainer: {
    width: '100%',
  },
  parentRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  parentRowItem: {
    flexGrow: 1,
    minWidth: 0,
  },
  chevron: {
    flexShrink: 0,
    width: '2rem',
    height: '2rem',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: tokens.colorNeutralForeground2,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    boxSizing: 'border-box',
    ...shorthands.borderStyle('none'),
    ...shorthands.padding('0'),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    transitionProperty: 'transform',
    transitionDuration: railTransitionDuration,
    transitionTimingFunction: railTransitionEasing,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    ':focus-visible': {
      outlineStyle: 'solid',
      outlineWidth: '2px',
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: '-2px',
    },
    '@media (prefers-reduced-motion: reduce)': {
      transitionDuration: '0ms',
    },
  },
  chevronOpen: {
    transform: 'rotate(90deg)',
  },
  nestedList: {
    listStyleType: 'none',
    ...shorthands.padding('0', '0', '0', tokens.spacingHorizontalS),
    ...shorthands.margin('0'),
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalXXS),
    overflowY: 'hidden',
    transitionProperty: 'max-height, opacity',
    transitionDuration: railTransitionDuration,
    transitionTimingFunction: railTransitionEasing,
    '@media (prefers-reduced-motion: reduce)': {
      transitionDuration: '0ms',
    },
  },
  nestedListClosed: {
    maxHeight: '0',
    opacity: 0,
    pointerEvents: 'none',
  },
  nestedListOpen: {
    maxHeight: '30rem',
    opacity: 1,
  },
  popoverSurface: {
    minWidth: '14rem',
    ...shorthands.padding(tokens.spacingVerticalXS),
  },
  flyoutList: {
    listStyleType: 'none',
    ...shorthands.padding('0'),
    ...shorthands.margin('0'),
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalXS),
  },
});
